import { MultiLevelCategory } from '@shopby/shop-sdk'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import { PropsType } from '../../@types/etc'
import { SectionDetailType } from '../../@types/home'
import { getSectionsDetail } from '../../api/home'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { onErrorImg } from '../../js/script'
import { useAppContext } from '../provider/AppProvider'

export default function HomeCategorySecond({ el, index, category }: PropsType) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [categoryItem, setCategoryItem] = useState<MultiLevelCategory[]>([])
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [])
  //패션인 카테고리만
  useEffect(() => {
    if (category?.multiLevelCategories) {
      const fashionCategory = category.multiLevelCategories.find((el: any) => el.label === '패션')
      if (fashionCategory) {
        setCategoryItem(fashionCategory?.children || [])
      }
    }
  }, [category])
  return (
    <>
      <div
        className='category'
        style={{ minHeight: isMobile ? '206px' : '225px' }}
        onClick={(): void => {
          const gtmNavigateClick: DataLayerArgs = {
            dataLayer: {
              event: 'select_content',
              event_info: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            },
          }
          if (isAppView) {
            sendSetAppsflyerEvent({
              eventName: 'select_content',
              eventType: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            })
          } else {
            TagManager.dataLayer(gtmNavigateClick)
          }
        }}
      >
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain}</strong>
          </p>
        </div>
        <div className='category_list'>
          <ul>
            {categoryItem.map((el: any) => {
              return (
                <li
                  key={el.categoryNo}
                  onClick={(): void => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/category/${el.categoryNo}/${el.categoryNo}/${el.categoryNo}`,
                      })
                    } else {
                      navigate(`/category/${el.categoryNo}/${el.categoryNo}/${el.categoryNo}`)
                    }
                  }}
                >
                  <div>
                    <img src={el.icon} alt='' onError={onErrorImg} />
                  </div>
                  <p>{el?.label}</p>
                </li>
              )
            })}
          </ul>
        </div>
        {index !== 0 && <hr />}
      </div>
    </>
  )
}
